import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="inicio" className="hero">
      <div className="hero-blob hero-blob-1" aria-hidden="true"></div>
      <div className="hero-blob hero-blob-2" aria-hidden="true"></div>
      <div className="container hero-inner">
        <div className="hero-content">
          <a href="#conquista" className="hero-badge">
            <i className="fas fa-trophy"></i>
            Semifinalistas do Desafio Liga Jovem Sebrae — Representando o Maranhão
          </a>

          <h1>Pague menos de <span className="highlight">R$ 2</span> por animal e tenha seu rebanho protegido</h1>
          <p>Solução completa em rastreabilidade e vacinação digital para equinos e bovinos. Garanta a saúde do seu rebanho com tecnologia de ponta e controle total, na palma da mão.</p>

          <div className="hero-buttons">
            <a href="#planos" className="btn">Conhecer Planos <i className="fas fa-arrow-right"></i></a>
            <a href="#contato" className="btn btn-outline-light">Fale Conosco</a>
          </div>

          <div className="hero-stats">
            <div className="hero-stat">
              <strong>95%</strong>
              <span>Controle vacinal</span>
            </div>
            <div className="hero-stat">
              <strong>100%</strong>
              <span>Rastreabilidade</span>
            </div>
            <div className="hero-stat">
              <strong>R$ 15</strong>
              <span>Microchip único</span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <img src="/assets/image/cavalo.jpg" alt="Equipe AgroVacina em campo com rebanho" />
          <div className="hero-visual-card">
            <i className="fas fa-shield-heart"></i>
            <div>
              <strong>Carteira digital</strong>
              <span>Vacinal por animal</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
